import { render, staticRenderFns } from "./Funnels.vue?vue&type=template&id=053778b5&scoped=true&"
import script from "./Funnels.vue?vue&type=script&lang=js&"
export * from "./Funnels.vue?vue&type=script&lang=js&"
import style0 from "./Funnels.vue?vue&type=style&index=0&id=053778b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053778b5",
  null
  
)

export default component.exports